export const events = {
  legalEntityCycleChanged: 'Legal entity cycle changed',
}
